// Constant data for Inventory

export const PRODUCT_STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}

export const INVENTORY_TYPE = {
  SELLER_PRODUCT           : 'Seller::Product',
  MERCHANT_PRODUCT_VARIANT : 'Merchant::Product::Variant'
}

export const MOVEMENT_ACTION = {
  MIGRATE_OLD_DATA          : 'migrate_old_data',
  CONSIGN                   : 'consign',
  PUT_AWAY                  : 'put_away',
  APPRAISAL                 : 'appraisal',
  FILL_APPRAISAL            : 'fill_appraisal',
  CONFIRM_BUYING_PRICE      : 'confirm_buying_price',
  BUYING_PRICE_CONFIRMATION : 'buying_price_confirmation',
  APPRAISAL_APPROVE         : 'appraisal_approve',
  APPROVE_APPRAISAL         : 'approve_appraisal',
  LIVE                      : 'live',
  AUTHENTICATION_CHECK      : 'authentication_check',
  RETURN_TO_VENDOR          : 'return_to_vendor',
  REQUEST                   : 'request',
  REQUEST_RETURN            : 'request_return',
  INTERNAL_REQUEST_PICK     : 'internal_request_pick',
  INTERNAL_REQUEST_RETURNED : 'internal_request_returned',
  INTERNAL_REQUEST_PUT_AWAY : 'internal_request_put_away',
  ORDER                     : 'order',
  CHECKOUT                  : 'checkout',
  CANCEL                    : 'cancel',
  ORDER_EXPIRE              : 'order_expire',
  ORDER_SHIPMENT            : 'order_shipment',
  SHIPMENT                  : 'shipment',
  REFUND                    : 'refund',
  MOVE_IN                   : 'move_in',
  MOVE_OUT                  : 'move_out',
  STOCK_OPNAME_CHECK_FOUND  : 'stock_opname_check_found',
  STOCK_OPNAME_CHECK_NOT_FOUND : 'stock_opname_check_not_found',
  MANUALLY_ADD_ITEM         : 'manually_add_item',
  MANUALLY_REMOVE_ITEM      : 'manually_remove_item',
  MANUAL_DELETE             : 'manual_delete',
  SWAP_BKR_TO_BKX           : 'swap_bkr_to_bkx',
  SWAP_BRV_TO_BKV           : 'swap_brv_to_bkv'
}

export const PROCESS_TYPE = {
  SELLER_INVENTORY_BATCH   : 'Seller::Inbound::InventoryBatch',
  MERCHANT_INVENTORY_BATCH : 'Merchant::Inbound::InventoryBatch',
  SELLER_OUTBOUND_RETURN   : 'Seller::Outbound::Return',
  MERCHANT_OUTBOUND_RETURN : 'Merchant::Outbound::Return',
  INTERNAL_REQUEST         : 'Admin::Outbound::InternalRequest',
  ORDER                    : 'Customer::Order',
  SHIPMENT                 : 'Customer::Shipment',
  REFUND                   : 'Customer::Refund'
}
